// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2T1zU","placeholdersHeader":"styles_placeholdersHeader__1s6GE","editorStyle":"styles_editorStyle__SRNZ6","placeholdersBox":"styles_placeholdersBox__24Kg0"};